export default function PugJSLogo() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 128 128"
      >
        <style type="text/css">
        </style>
        <g>
          <path
            fill="#EFCCA3"
            className="st1"
            d="M107.4,50.9c-0.2-4.4,0.4-8.3-1.6-11.6c-4.8-8.2-16.8-13-40.8-13V27c0,0-0.5,0-0.5,0c0,0,0.5,0,0.5,0v-0.7   c-24,0-36.6,4.8-41.4,13.1c-1.9,3.4-1.7,7.2-2,11.6c-0.2,3.5-1.8,7.2-1.1,11.2c0.8,5.2,1.1,10.4,1.9,15.2c0.6,3.9,6,7.2,6.5,10.9   c1.4,10.2,12,14.9,36,14.9v0.8h-0.6h0.1H65v-0.8c24,0,34.2-4.7,35.5-14.9c0.5-3.8,5.5-7,6.1-10.9c0.8-4.8,1.1-10,1.9-15.2   C109.2,58.2,107.6,54.4,107.4,50.9z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M64.6,54.5c4.3,0.1,7.3,2.8,10.1,5.3c3.3,2.9,8.9,4.9,11.2,7.4c2.3,2.5,5.3,5,6.4,8.9   c1.1,3.9,1.4,8.9,1.4,10.2c0,1.3,0.7,1,2.7,0c4.7-2.3,9.9-8.5,9.9-8.5c-0.6,3.9-5.7,7.4-6.2,11.1C98.9,99.1,89,104,64.5,104h-0.1h0   H65"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M80.4,46.7c0.9,3.1,4.1,13.6-2.1,10.1c0,0,2.6,1.5,4.2,7.2c1.7,5.7,5.8,6.4,5.8,6.4s6.7,1.3,11.7-3   c4.2-3.6,4.9-10,3.1-14.9c-1.8-4.8-5-6.3-9.7-7.3C88.7,44.1,79.3,43.2,80.4,46.7z"
          />
          <g>
            <circle cx="92.3" cy="58.1" r="8.8" />
            <circle fill="#FFFFFF" className="st4" cx="90" cy="54.2" r="2.3" />
          </g>
          <path
            fill="#EFCCA3"
            className="st1"
            d="M78.9,57.7c0,0,7.9,5.4,12.2,10.7c4.3,5.3,4.2,6.3,4.2,6.3l-3.1,1.4c0,0-4.4-8.3-9.8-11.4   c-5.5-3.1-6.1-5.7-6.1-5.7L78.9,57.7z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M64.9,54.5c-4.3,0.1-7.5,2.8-10.4,5.3c-3.3,2.9-9.1,4.9-11.4,7.4c-2.3,2.5-5.4,5-6.5,8.9   c-1.1,3.9-1.5,8.9-1.5,10.2c0,1.3,0.2,1.4-2.7,0c-4.7-2.2-9.9-8.5-9.9-8.5c0.6,3.9,5.7,7.4,6.2,11.1C30.1,99.1,40,104,64.5,104h0.1   h0H65"
          />
          <path
            fill="#56332B"
            className="st7"
            d="M88.1,71.4C83.3,65.5,75.6,60,64.9,60h-0.1h0c-10.7,0-18.4,5.5-23.2,11.4c-5,6.1-4.6,8.5-4.6,14.3   c0,21,7.4,15,12.3,17.6c5,2.5,10.2,1.7,15.5,1.7h0h0.1c5.4,0,10.5,0.7,15.5-1.8c4.9-2.5,12.3,3.7,12.3-17.3   C92.8,80.1,93.1,77.5,88.1,71.4z"
          />
          <path
            fill="#442823"
            className="st8"
            d="M64.4,65.2c0,0-0.7,9.7-2.1,11.6l2.6-0.6L64.4,65.2z"
          />
          <path
            fill="#442823"
            className="st8"
            d="M65.1,65.2c0,0,0.7,9.7,2.1,11.6l-2.6-0.6L65.1,65.2z"
          />
          <path
            fill="#56332B"
            className="st7"
            d="M56.7,62.9c-1-2.3,2.6-6,8.3-6.1c5.7,0,9.3,3.7,8.3,6.1c-1,2.4-4.6,3.1-8.3,3.2C61.4,66,57.7,65.3,56.7,62.9z"
          />
          <path d="M65,65.2c0-0.4,3.4-0.5,5.2-1.7c0,0-3.7,1.2-4.5,0.7c-0.8-0.4-1-1.6-1-1.6s-0.3,1.2-0.9,1.6c-0.7,0.4-4.9-0.7-4.9-0.7   s5.6,1.4,5.6,1.7c0,0.3-0.1,1.3-0.1,2c0,2.5,0,8.7,0.4,9.2c0.6,0.9,0.4-6.7,0.4-9.2C65.1,66.4,65.1,65.6,65,65.2z" />
          <path
            fill="#7F4A41"
            className="st9"
            d="M65.2,78.6c1.7,0,4.7,1.2,7.4,3.1c-2.6-2.9-5.7-4.9-7.4-4.9c-1.8,0-5.6,2.2-8.3,5.4   C59.7,80,63.3,78.6,65.2,78.6z"
          />
          <path
            fill="#442823"
            className="st8"
            d="M64.5,96.3c-3.8,0-7.5-1.2-10.9-2.1c-0.7-0.2-1.4,0.3-2.1,0.1c-6.3-2-11.4-5.4-14.5-9.7c0,0.3,0,0.7,0,1   c0,21,7.4,15.1,12.3,17.6c5,2.5,10.2,1.7,15.5,1.7h0h0.1c5.4,0,10.5,0.7,15.5-1.8c4.9-2.5,12.3,3.6,12.3-17.4c0-0.8,0-1.6,0.1-2.3   c-2.9,4.7-8.2,8.4-14.8,10.6c-0.6,0.2-2-0.3-2.6-0.2C71.8,95,68.6,96.3,64.5,96.3z"
          />
          <path
            fill="#442823"
            className="st8"
            d="M55,85c0,0-2.5,7.5-0.8,10.8l-2.3-1C51.9,94.8,53.6,87.2,55,85z"
          />
          <path
            fill="#442823"
            className="st8"
            d="M74.8,85c0,0,2.5,7.5,0.8,10.8l2.3-1C77.9,94.8,76.1,87.2,74.8,85z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M48.6,46.7c-0.9,3.1-4.1,13.6,2.1,10.1c0,0-2.6,1.5-4.2,7.2s-5.8,6.4-5.8,6.4s-6.7,1.3-11.7-3   c-4.2-3.6-4.9-10-3.1-14.9s5-6.3,9.7-7.3C40.3,44.1,49.6,43.2,48.6,46.7z"
          />
          <path d="M64.9,76.8c2.7,0,11.1,5.8,11.2,12.9c0-0.1,0-0.2,0-0.4c0-7.4-6.8-13.3-11.2-13.3c-4.4,0-11.2,6-11.2,13.3   c0,0.1,0,0.2,0,0.4C53.8,82.6,62.2,76.8,64.9,76.8z" />
          <g>
            <ellipse
              transform="matrix(0.9683 -0.2497 0.2497 0.9683 -13.2339 18.6065)"
              fill="#331712"
              className="st10"
              cx="66.7"
              cy="61.5"
              rx="0.8"
              ry="1.5"
            />

            <ellipse
              transform="matrix(0.9551 0.2963 -0.2963 0.9551 21.0115 -15.7209)"
              fill="#331712"
              className="st10"
              cx="62.4"
              cy="61.5"
              rx="0.8"
              ry="1.5"
            />
          </g>
          <g>
            <circle cx="37.2" cy="58.1" r="8.8" />
            <circle fill="#FFFFFF" className="st4" cx="39.5" cy="54.2" r="2.3" />
          </g>
          <g>
            <path
              fill="#7F4A41"
              className="st9"
              d="M67.5,58.2c0-0.1-2.3,1-2.9,1.1c-0.6-0.1-2.9-1.2-2.9-1.1c0,0,1.9,0,2.9,0C65.6,58.2,67.5,58.2,67.5,58.2z"
            />
          </g>
          <path
            fill="#EFCCA3"
            className="st1"
            d="M50,57.7c0,0-7.9,5.4-12.2,10.7c-4.3,5.3-4.2,6.3-4.2,6.3l3.1,1.4c0,0,4.4-8.3,9.8-11.4s6.1-5.7,6.1-5.7   L50,57.7z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M32.7,41.7c0,0-2.7,7.4-8.7,10.5C24,52.2,33.4,51.1,32.7,41.7z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M95.8,41.7c0,0,2.7,7.4,8.7,10.5C104.5,52.2,95.1,51.1,95.8,41.7z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M78.7,55.5c0,0-5.9-6.2-13.8-6.4l0,0c-0.1,0,0.2,0,0.1,0c-0.1,0,0.1,0,0.1,0v0c-8,0.2-13.8,6.4-13.8,6.4   c6.9-4.8,12.8-4.7,13.8-4.7v0c0,0,0,0,0,0c0,0,0,0,0,0v0C65,50.8,71.8,50.7,78.7,55.5z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M71.8,42.5c0,0-3-4.2-7-4.3l0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0v0c-3,0.1-6.9,4.3-6.9,4.3   c3.4-3.3,6.9-3.2,6.9-3.2v0c0,0,0,0,0,0c0,0,0,0,0,0v0C65,39.3,68.3,39.2,71.8,42.5z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M37.2,73.2c0,0-4.7,2.3-8.1,0.9l0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0v0c-3-1.7-4.5-6.8-4.5-6.8   S27.5,76.3,37.2,73.2z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M92,73.2c0,0,4.7,2.3,8.1,0.9l0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c4-1.7,4.6-6.8,4.6-6.8S101.7,76.3,92,73.2z"
          />
          <g>
            <path
              fill="#CCAC8D"
              className="st3"
              d="M42.6,41.2c2.6-0.5,6.9-0.6,10.3,0.5c4.3,1.5,0.8,7,1.7,7.3c0.9,0.3,2.1-3.8,10.1-3.4c8.1,0.4,9,4,10.1,3.4    s-1.1-10,11-7.8c0,0-12.7-3.4-12.1,5.8c0,0-7.3-5.6-17.5-0.6C56.3,46.4,58.9,37.8,42.6,41.2z"
            />
          </g>
          <path
            fill="#CCAC8D"
            className="st3"
            d="M86.9,41.2c0.2,0,0.3,0.1,0.4,0.1C87.4,41.3,87.2,41.2,86.9,41.2z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M86.9,41.2C86.9,41.2,86.9,41.2,86.9,41.2C86.9,41.2,86.9,41.2,86.9,41.2z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M39.1,28.9c0,0-10.8,13.6-12.4,18.8c-1.6,5.3-2.8,27-4.2,30.1l-5-21.4l9.2-22.3L39.1,28.9z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M89.9,28.9c0,0,10.8,13.6,12.4,18.8c1.6,5.3,2.8,27,4.2,30.1l5-21.4l-9.2-22.3L89.9,28.9z"
          />
          <path
            fill="#56332B"
            className="st7"
            d="M89.4,28.9c0,0,11.6,9.7,15,20.9c3.4,11.2,2,24.8,4.6,26.5c3.7,2.4,7.9-11.9,9.3-13.4c2.2-2.4,9.5-8.5,10-9.6   c0.5-1.1-14.8-17.8-21.5-21.1C98.7,28.4,88.7,28.1,89.4,28.9z"
          />
          <path
            fill="#442823"
            className="st8"
            d="M99.3,34.9c0,0,13.7,17.5,13.5,39.3l5.5-11.2C118.2,63,113.4,48.7,99.3,34.9z"
          />
          <path
            fill="#56332B"
            className="st7"
            d="M39.1,28.9c0,0-11.6,9.7-15,20.9s-2,24.8-4.6,26.5c-3.7,2.4-7.9-11.9-9.3-13.4c-2.2-2.4-9.5-8.5-10-9.6   c-0.5-1.1,14.8-17.8,21.5-21.1C29.8,28.4,39.8,28.1,39.1,28.9z"
          />
          <path
            fill="#442823"
            className="st8"
            d="M29.2,34.9c0,0-13.7,17.5-13.5,39.3L10.3,63C10.3,63,15.1,48.7,29.2,34.9z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M21.8,74.6c0,0,1,5.4,2.6,7.1s0.5-1.3,0.5-1.3s-1.7-0.9-1.4-7.8S21.8,74.6,21.8,74.6z"
          />
          <path
            fill="#CCAC8D"
            className="st3"
            d="M107.1,74.6c0,0-1,5.4-2.6,7.1s-0.5-1.3-0.5-1.3s1.7-0.9,1.4-7.8S107.1,74.6,107.1,74.6z"
          />
          <g>
            <circle fill="#442823" className="st8" cx="54.5" cy="70.5" r="0.8" />
            <circle fill="#442823" className="st8" cx="49.9" cy="75.3" r="0.8" />
            <circle fill="#442823" className="st8" cx="48.4" cy="70.5" r="0.8" />
          </g>
          <g>
            <circle fill="#442823" className="st8" cx="74" cy="70.5" r="0.8" />
            <circle fill="#442823" className="st8" cx="78.6" cy="75.3" r="0.8" />
            <circle fill="#442823" className="st8" cx="80.1" cy="70.5" r="0.8" />
          </g>
        </g>
      </svg>
    </div>
  );
}
